import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Serviceuna() {
  return (
    <section
      className="service_una p-100 text_una"
      style={{ background: "#E8FEF3" }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={5}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center resp_order"
          >
            <div className="banner_img">
              <StaticImage
                src="../../../images/case-studies/una/service_img.webp"
                alt="TekRevol"
                className=""
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={723}
                height={604}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-1"
          >
            <h2>
              <strong>
                Tekrevol – Your Service Provider For High-End Mobile
                Applications
              </strong>
              Opt For Digital Solution That Can Bring Revolution Your Brand
            </h2>
            <p>
              The Tekrevol team can offer so much more than Android or iOS
              mobile app development services. We are a full-fledged tech firm
              that can provide a wide array of digital solutions catered to your
              business needs, applicable across multiple platforms. If you're
              looking for a similar mobile app or if you have an app idea that
              will take the market by the storm, we would be obliged to be your
              partner in your journey. Contact us to get a custom solution
              within your budget today. We take pride in delivering great
              quality and projects.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Serviceuna;
